var _circle, _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsentIndication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#0044C6",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4707_150655)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4707_150655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 27V7H27V20.4431C26.9601 19.9698 26.7595 19.5076 26.3981 19.1465C25.5863 18.334 24.2641 18.334 23.4523 19.1465L20.7587 21.8394L19.4539 20.5353C18.6421 19.7229 17.32 19.7229 16.5082 20.5353C15.6957 21.3471 15.6957 22.6693 16.5082 23.481L19.2859 26.2587C19.6789 26.6524 20.2025 26.8691 20.7587 26.8691C21.3149 26.8691 21.8385 26.6524 22.2316 26.2587L26.3981 22.0922C26.7595 21.7311 26.9601 21.2689 27 20.7956V27L7 27Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4707_150655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 9.5C15.1591 9.5 13.6667 10.9924 13.6667 12.8333C13.6667 14.6743 15.1591 16.1667 17 16.1667C18.841 16.1667 20.3333 14.6743 20.3333 12.8333C20.3333 10.9924 18.841 9.5 17 9.5ZM17 18.6667C14.4967 18.6667 9.5 19.9233 9.5 22.4167V23.6667C9.5 24.1267 9.87333 24.5 10.3333 24.5H23.6667C24.1267 24.5 24.5 24.1267 24.5 23.6667V22.4167C24.5 19.9233 19.5033 18.6667 17 18.6667Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7589 25.4808C20.5811 25.4808 20.4033 25.4127 20.2679 25.2773L17.4903 22.4997C17.2187 22.2281 17.2187 21.7893 17.4903 21.5178C17.7618 21.2462 18.2006 21.2462 18.4722 21.5178L20.7589 23.8045L24.4344 20.1289C24.7059 19.8574 25.1448 19.8574 25.4163 20.1289C25.6878 20.4004 25.6878 20.8393 25.4163 21.1108L21.2498 25.2773C21.1144 25.4127 20.9366 25.4808 20.7589 25.4808Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4707_150655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsentIndication);
export default __webpack_public_path__ + "static/media/consent_indication.d46469ad4a20f5981e2f29af99c02079.svg";
export { ForwardRef as ReactComponent };